define((require) => {
    "use strict";

    const Effect      = require("shared/ui/experience/widgets/effects/Effect");
    const EffectModel = require("shared/ui/experience/action/effects/EffectModel");

    const OpacityEffect = Effect.extend({

        duration(triggerType) {
            return triggerType === EffectModel.TRIGGER_TYPE_HOVER ? 0.100 : null;
        },

        config() {
            return {
                opacity: this.model.get("opacity"),
                ease: Effect.Easing.Linear.easeNone
            };
        }
    });

    return OpacityEffect;
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/effects/OpacityEffect.js